<template>
  <div class="bg-white rounded-sm mx-2 my-3">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mx-3 mt-3">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <span class="title">Registry File</span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-4 mx-3 mt-2">
      <div class="col-span-12 mx-auto bg-gray-10 py-3 rounded">
        <span class="cursor-pointer text-blue hover:text-blue-dark hover:underline" @click="back">Back</span> <span class="ml-3 text-gray">Business / {{brn}}</span>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-4 mx-3">
      <div class="col-span-12 mx-auto my-3 shadow-sm rounded pt-2 pb-4 border border-blue">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4" v-if="getEntityFile">
            <div class="col-span-12 mt-3">
              <span class="font-bold text-blue h5">{{getEntityFile.brn}}</span><br/>
              <span class="font-bold text-gray h3">{{getEntityFile.name}}</span><br/>
              <div class="flex mt-1">
                  <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                    {{cleanEntityType(type)}}
                  </span>
                  <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs mx-1 bg-green text-capitalize">
                    {{cleanEntityType(getEntityFile.subType)}}
                  </span>
              </div>
              <span class="italic text-gray text-xs font-bold" v-if="getEntityFile.dateOfRegistration">Registration Date: {{dateFormat(getEntityFile.dateOfRegistration)}}</span><br/>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4" v-else>
            <div class="col-span-12 my-3 blink_me">
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-gray_loading text-gray_loading my-1 w-2/12">name</span><br/>
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-gray_loading text-gray_loading py-3 w-4/12">name</span>
              <div class="flex mt-1">
                <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-gray_loading">
                  loading...
                </span>
                <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs mx-1 bg-gray_loading">
                  loading...
                </span>
              </div>
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-gray_loading my-1 text-gray_loading w-6/12">name</span>
              <br/>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4" v-if="getEntityFile">
            <div class="col-span-12">
              <CompanyFile :company="getEntityFile" v-if="type === 'company' && !getEntityFile.subType.includes('foreign')"/>
              <ForeignCompanyFile :company="getEntityFile" v-if="type ===  'company' && getEntityFile.subType.includes('foreign')"/>
              <BusinessNameFile :business="getEntityFile" v-if="type === 'business'"/>
              <BuildingSocietyFile :society="getEntityFile" v-if="type === 'building-society'"/>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4" v-else>
            <div class="col-span-12 bg-gray_loading py-5 blink_me">

            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { cleanEntityType, dateFormat } from "@/commons/composables/utilities";
import { useBusinessRegistryStore } from "@/stores/business-registry";
import CompanyFile from "@/domains/home/services/registry/business/files/CompanyFile.vue";
import BusinessNameFile from "@/domains/home/services/registry/business/files/BusinessNameFile.vue";
import BuildingSocietyFile from "@/domains/home/services/registry/business/files/BuildingSocietyFile.vue";
import ForeignCompanyFile from "@/domains/home/services/registry/business/files/ForeignCompanyFile.vue";

const route = useRoute();
const registryStore = useBusinessRegistryStore();

const brn = ref<string | null>(null);
const type = ref("");
const loading = ref(false);

const getEntityFile = computed(() => registryStore.entity_file);

onMounted(() => {
  brn.value = route.params.id as string;
  type.value = localStorage.getItem("entityType") ?? "";

  loading.value = true;
  if (type.value === "company") {
    registryStore.fetchCompanyByBRN(brn.value);
  }
  if (type.value === "business") {
    registryStore.fetchBusinessNameByBRN(brn.value);
  }
  if (type.value === "building-society") {
    registryStore.fetchBuildingSocietyByBRN(brn.value);
  }
})

watch(() => registryStore.entity_file, () => {
  loading.value = false;
});

const back = () => {
  window.history.back();
}
</script>

